import { Images } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { AssetRoutes } from "./routes";
import { ASSET_BROWSE_PERMISSIONS } from "./permissions";

export const assetsNav: INavItem = {
  labelKey: "nav.assets",
  icon: Images,
  path: AssetRoutes.INDEX,
  permissions: [...ASSET_BROWSE_PERMISSIONS],
};
